import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectSiteNameStepInput } from './components/SelectSiteNameStepInput';
import { useAppStore } from 'stores/state';
import { SelectSiteNameStepSuggestions } from './components/SelectSiteNameStepSuggestions';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectSiteNameStep: FC = () => {
  const { t } = useTranslation();
  const siteName = useAppStore((state) => state.siteName);

  return (
    <StepLayout
      disclaimer={t('select-site-name-step.disclaimer')}
      description={t('select-site-name-step.description')}
      title={t('select-site-name-step.title')}
      nextButtonProps={{ label: t('select-site-name-step.primary-button'), disabled: !siteName }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectSiteName],
          action: BI_ACTION_NAME.NEXT,
          value: siteName,
        });
      }}
    >
      <SelectSiteNameStepInput />
      <SelectSiteNameStepSuggestions />
    </StepLayout>
  );
};
